import React from "react";
import { Image, type ImageProps } from "tamagui";

const assetCache: { [assetUrl: string]: number } = {};

export const ImageFit = ({
  assetUrl,
  ...props
}: { assetUrl: string } & ImageProps) => {
  const [aspectRatio, setAspectRatio] = React.useState<number | undefined>(
    assetCache[assetUrl],
  );

  React.useEffect(() => {
    Image.getSize(assetUrl, (width, height) => {
      setAspectRatio(width / height);

      assetCache[assetUrl] = width / height;
    });
  }, [assetUrl]);

  if (!aspectRatio) return null;

  return (
    <Image
      resizeMode="contain"
      width="100%"
      aspectRatio={aspectRatio}
      source={{ uri: assetUrl }}
      {...props}
    />
  );
};
